import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconKey } from '../../../../../whitelabel/icon-key.enum';
import { WhitelabeledComponentKey } from '../../../../../whitelabel/whitelabel-component-types';
import { ButtonComponent } from '../../../../osp-ui/components/button/button/button.component';
import { Authorities } from '../../../../shared/enums/authorities.enum';
import { Modules } from '../../../../shared/enums/modules.enum';
import { IconPipe } from '../../../../shared/pipes/icon.pipe';
import { AccessService } from '../../../../shared/services/access.service';
import { EntityCreateControllerService } from '../../../../shared/services/entity-create-controller.service';
import { ComponentPlaceholderComponent } from '../../../../whitelabel/components/component-placeholder/component-placeholder.component';
import { WhitelabeledComponent } from '../../../../whitelabel/components/whitelabeled-component/whitelabeled-component.component';
import { AuthService } from '../../../services/auth.service';
import { AutomatedTransfersNotificationsCenterOverlayComponent } from './automated-transfers-notifications-center-overlay/automated-transfers-notifications-center-overlay.component';
import { EquipmentAttentionOverlayComponent } from './equipment-attention-overlay/equipment-attention-overlay.component';
import { HelpOverlayComponent } from './help-overlay/help-overlay.component';
import { NotificationsCenterOverlayComponent } from './notifications-center-overlay/notifications-center-overlay.component';
import { CanSeeAutomatedTransfersOverlayService } from './services/can-see-automated-transfers-overlay.service';
import { UserSettingsMenuComponent } from './user-settings-menu/user-settings-menu.component';

@Component({
  selector: 'osp-topbar',
  standalone: true,
  imports: [
    HelpOverlayComponent,
    NotificationsCenterOverlayComponent,
    EquipmentAttentionOverlayComponent,
    WhitelabeledComponent,
    AutomatedTransfersNotificationsCenterOverlayComponent,
    ButtonComponent,
    IconPipe,
    TranslateModule,
  ],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarComponent implements OnInit {
  private authService = inject(AuthService);
  private canSeeAutomatedTransfersOverlayService = inject(CanSeeAutomatedTransfersOverlayService);
  private readonly entityCreateControllerService = inject(EntityCreateControllerService);
  private readonly accessService = inject(AccessService);

  readonly $canSeeAutomatedTransfersNotificationsOverlay = this.canSeeAutomatedTransfersOverlayService.$canSee;
  readonly $canSeeNotifications = signal(
    this.authService.hasAuthority(Authorities.NOTIFICATIONS_VIEW_ALARMS) && this.authService.hasModule(Modules.ALARMS),
  );
  readonly $canSeeAttention = signal(this.authService.hasAuthority(Authorities.EQUIPMENT_VIEW));
  readonly canCreateNewEntity = this.accessService.canCreateNewEntity();
  readonly IconKey = IconKey;
  protected readonly WhitelabeledComponentKey = WhitelabeledComponentKey;
  protected readonly ComponentPlaceholderComponent = ComponentPlaceholderComponent;
  protected readonly UserSettingsMenuComponent = UserSettingsMenuComponent;

  ngOnInit(): void {
    this.canSeeAutomatedTransfersOverlayService.setVisibility();
  }

  createNewEntity(): void {
    this.entityCreateControllerService.createNewEntity();
  }
}
